import { LOADING_ORGANIZATION, LOAD_ORGANIZATIONS } from '../actions';

export const initialState = {
  loading: false
};

const organization = (state = initialState, action) => {
  switch (action.type) {
    case LOADING_ORGANIZATION:
      return {
        ...state,
        loading: action.loading
      };
    case LOAD_ORGANIZATIONS:
      return {
        ...state,
        loading: false,
        organizations: {
          entities: action.organizations.reduce((map, organization) => {
            map[organization.id] = organization;
            return map;
          }, {}),
          ids: action.organizations.map(organization => organization.id)
        }
      };
    default:
      return state;
  }
};

export default organization;



// WEBPACK FOOTER //
// ./src/reducers/organization.js